// src/components/ContactSelection.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './ContactSelection.css';

const ContactSelection = () => {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
    };
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await fetch(`https://tophamtechbe.com/treas-postgrid/s3/get-address-list/${SITE_CONFIG.SITE_ID}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const contactsWithAddress = (data.contacts || []).filter(contact => contact.Address1 && contact.Address1.trim() !== '');
        setContacts(contactsWithAddress);
      }
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleContactSelect = (contact, index) => {
    const contactId = `${contact.Name}-${index}`;
    if (selectedContacts.includes(contactId)) {
      setSelectedContacts(selectedContacts.filter(id => id !== contactId));
    } else {
      setSelectedContacts([...selectedContacts, contactId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedContacts.length === contacts.length) {
      setSelectedContacts([]);
    } else {
      setSelectedContacts(contacts.map((contact, index) => `${contact.Name}-${index}`));
    }
  };

  if (loading) {
    return <div className="contact-loading">Loading contacts...</div>;
  }

  return (
    <div className="contact-selection">
      <div className="contact-header">
        <h1>Step 1: Select Contacts</h1>
        <button onClick={() => navigate('/admin/mail-marketing')} className="back-button">
          Back to Mail Marketing
        </button>
      </div>

      <div className="selection-controls">
        <button onClick={handleSelectAll} className="select-all-button">
          {selectedContacts.length === contacts.length ? 'Deselect All' : 'Select All'}
        </button>
        <span className="selected-count">
          {selectedContacts.length} of {contacts.length} contacts selected
        </span>
      </div>

      <div className="contacts-grid">
        {contacts.map((contact, index) => {
          const contactId = `${contact.Name}-${index}`;
          const isSelected = selectedContacts.includes(contactId);
          
          return (
            <div 
              key={index} 
              className={`contact-card ${isSelected ? 'selected' : ''}`}
              onClick={() => handleContactSelect(contact, index)}
            >
              <div className="contact-checkbox">
                <input 
                  type="checkbox" 
                  checked={isSelected}
                  onChange={() => handleContactSelect(contact, index)}
                />
              </div>
              <div className="contact-info">
                <div className="contact-name">{contact.Name}</div>
                {contact.CompanyName && <div className="contact-company">{contact.CompanyName}</div>}
                {contact.PhoneNumber && <div className="contact-phone">{contact.PhoneNumber}</div>}
                <div className="contact-address">
                  <div className="address-line">{contact.Address1} {contact.Address2 && `, ${contact.Address2}`}</div>
                  <div className="address-line">{contact.City}, {contact.State} {contact.Zip}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {selectedContacts.length > 0 && (
        <div className="next-step">
          <button 
            className="next-button"
            onClick={() => {
              const selectedContactData = contacts.filter((contact, index) => 
                selectedContacts.includes(`${contact.Name}-${index}`)
              );
              navigate('/admin/mail-marketing/upload', { 
                state: { selectedContacts: selectedContactData } 
              });
            }}
          >
            Next Step ({selectedContacts.length} contacts selected)
          </button>
        </div>
      )}
    </div>
  );
};

export default ContactSelection;